import React, { Component } from 'react';
import { Button, Modal, Checkbox } from 'antd';
import router from 'umi/router';
import { stringify } from 'qs';
import { connect } from 'dva';
import Container from '../../../../../components/Container';
import ListPage from '../../../../../components/ListPage';
import { getComposeUrl } from '../../../../../utils/common';
import { getAppCode, GetQueryString } from '../../utils/utils';
import styles from './index.less';

const { ListTable } = ListPage;
let timer = null;

const options = [
  { label: '未完成学习', value: '0' },
  { label: '学习中', value: '2' },
  { label: '已完成学习', value: '1' },
];


@connect(({ user }) => {
  return {
    orgId: user.currentUser.orgId,
  };
})
class StudyNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      columns: [],
      dataSource: [],
      visible: false,
      params: {
        page: 1,
        pageSize: 10,
        appCode: getAppCode(),
        newsId: GetQueryString('id'),
      },
      clickExport: false,
      downloadurl: '',
      showDownload: false,
      checkedValues: []
    };
    this.title = GetQueryString('title');
  }

  componentDidMount() {
    const { params } = this.state;
    this.setColumns();
    this.fetchNewsDetail(params);
  }

  componentWillUnmount() {
    clearTimeout(timer);
  }

  setColumns = () => {
    const columns = [
      {
        title: '课程名称',
        dataIndex: 'title',
        key: 'title',
        width: 500,
      },
      {
        title: '完成学习人数',
        dataIndex: 'counted',
        key: 'counted',
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        render: (text, record) => {
          return <a onClick={() => this.goRead(record)}>详情</a>;
        },
      },
    ];
    this.setState({ columns });
  };

  fetchNewsDetail = params => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'courseManage/fetchNewsDetail',
      params,
    })
      .then(res => {
        this.setState({
          dataSource: res.content,
          loading: false,
          totalElements: res.totalElements,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleOk = () => {
    this.fetchNewsDetailExport();
    this.setState({
      visible: false,
      clickExport: true,
      showDownload: true,
    });
  };

  handleCancel = () => {
    this.setState({ visible: false, clickExport: false, });
  };

  fetchNewsDetailExport = () => {
    const { dispatch } = this.props;
    const { checkedValues } = this.state;
    this.setState({ loading: true });
    dispatch({
      type: 'courseManage/fetchNewsDetailExport',
      params: { exportType: checkedValues.join(','), appCode: getAppCode(), newsId: GetQueryString('id') },
    })
      .then(res => {
        this.setState(
          {
            loading: false,
          },
          () => {
            this.setState({ loading: false, downloadurl: '' }, () => {
              this.fetchExportDownload(res);
              timer = setInterval(() => {
                this.fetchExportDownload(res);
              }, 60000);
            });
          }
        );
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchExportDownload = fileKey => {
    const { dispatch } = this.props;
    dispatch({
      type: 'courseManage/fetchExportDownload',
      params: { appCode: getAppCode(), fileKey },
    })
      .then(res => {
        if (res) {
          this.setState({ downloadurl: res, clickExport: false });
          clearTimeout(timer);
        }
      })
      .catch(() => {
        clearTimeout(timer);
        this.setState({ loading: false });
      });
  };

  changePage = (page, pageSize) => {
    const { params } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    this.setState({ params: tempParams });
    this.fetchNewsDetail(tempParams);
  };

  goRead = record => {
    const { orgId } = this.props;
    router.push(
      `${getComposeUrl('/readDetail')}?${stringify({
        infoId: record.newsId,
        countId: 3,
        appId: getAppCode(),
        parentId: orgId,
      })}`
    );
  };

  onCheckboxChange = (checkedValues) => {
    this.setState({ checkedValues })
  }

  downStatus = checkedValues => {
    const arr = []
    options.forEach(item => {
      if (checkedValues.indexOf(item.value) > -1) {
        arr.push(item.label)
      }
    })
    return arr.join()
  }


  render() {
    const {
      loading,
      params,
      totalElements,
      columns,
      dataSource,
      visible,
      clickExport = false,
      downloadurl = '',
      showDownload,
      checkedValues
    } = this.state;
    const { page } = params;
    const pageProps = {
      spinProps: { spinning: loading },
    };
    const tableProps = {
      pageInfo: { totalElements, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      onPageChange: this.changePage,
    };

    return (
      <Container breStates isSplitBar>
        <ListPage {...pageProps}>
          <div className={styles.root}>
            <div>
              {showDownload && (
                <div className='download-wrap'>
                  <div className='title'>
                    {this.title}（{this.downStatus(checkedValues)}）
                  </div>
                  {downloadurl && downloadurl.url ? (
                    <div>
                      数据生成时间: {downloadurl.buildTime}，如需更新请重新导出{' '}
                      <a href={downloadurl.url} download>
                        点击下载
                      </a>
                    </div>
                  ) : (
                      <div>数据生成中</div>
                    )}
                </div>
              )}
            </div>
            <div className={`export-wrap ${showDownload && 'showDownload'}`}>
              <div>当天完成学习人数需要在凌晨更新，次日生效</div>
              <Button
                type="primary"
                disabled={clickExport}
                onClick={() => this.setState({ visible: true })}
              >
                导出学习成绩
              </Button>
            </div>
          </div>
          <ListTable {...tableProps} />
        </ListPage>
        {visible && (
          <Modal
            title="选择导出范围"
            visible={visible}
            centered
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            wrapClassName='course-manage-study-modal'
          >
            <div className='choose-status-text'>请选择完成状态后点击导出</div>
            <Checkbox.Group options={options} onChange={this.onCheckboxChange} />
            <div className='tips' style={{ fontSize: 14, color: 'rgba(0, 0, 0, 0.45)', marginTop: 5 }}>
              说明: 人员范围超过5000人建议仅导出【已完成】等单状态的记录，否则课程耗时较长。
            </div>
          </Modal>
        )}
      </Container>
    );
  }
}
export default StudyNumber;
